import api from './api'

export interface AdminUser {
  id: number
  email: string
  email_verified: boolean
  role: string
  created_at: string
  plan: string | null
  subscription_status: string | null
  subscription_expires_at: string | null
  tokens_limit: number | null
  tokens_used: number | null
  channels_count: number
  leads_count: number
  telegram_connected: boolean
  ai_tokens_total: number
  ai_cost_usd: number
}

export interface AdminStats {
  total_users: number
  verified_users: number
  active_subscriptions: number
  expired_subscriptions: number
  total_channels: number
  total_leads: number
  telegram_connected: number
  ai_tokens_today: number
  ai_cost_today: number
  ai_tokens_total: number
  ai_cost_total: number
  users_registered_7d: number
}

export interface SystemPrompt {
  key: string
  title: string
  description: string | null
  module: string
  prompt_text: string
  is_default: boolean
  updated_at: string | null
}

export const adminService = {
  async getUsers(params?: { q?: string; limit?: number; offset?: number }) {
    const res = await api.get<AdminUser[]>('/admin/users', { params })
    return res.data
  },

  async getUser(userId: number) {
    const res = await api.get<AdminUser>(`/admin/users/${userId}`)
    return res.data
  },

  async updateUser(userId: number, data: { role?: string; email_verified?: boolean }) {
    const res = await api.patch(`/admin/users/${userId}`, data)
    return res.data
  },

  async updateSubscription(userId: number, data: Record<string, unknown>) {
    const res = await api.patch(`/admin/users/${userId}/subscription`, data)
    return res.data
  },

  async getStats() {
    const res = await api.get<AdminStats>('/admin/stats')
    return res.data
  },

  async getPlans() {
    const res = await api.get('/admin/plans')
    return res.data
  },

  // Prompts
  async getPrompts() {
    const res = await api.get<SystemPrompt[]>('/admin/prompts')
    return res.data
  },

  async updatePrompt(key: string, prompt_text: string) {
    const res = await api.put(`/admin/prompts/${key}`, { prompt_text })
    return res.data
  },

  async resetPrompt(key: string) {
    const res = await api.delete(`/admin/prompts/${key}`)
    return res.data
  },
}
